<script>
    export let title = 'default title';
</script>

<div class="main-title">
    <h2>{title}</h2>
</div>

<style>
    .main-title {
        text-transform: capitalize;
        color: var(--primaryColor);
        margin-bottom: 2rem;
    }
</style>
